import { useState, useEffect } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function PortalProfile() {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({ name: "", company: "", phone: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) setForm({ name: user.name || "", company: user.company || "", phone: user.phone || "" });
  }, [user]);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put("/portal/profile", form);
      setUser(data);
      toast.success("Profile updated");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div>
      <h1 className="font-display text-2xl font-bold">Profile</h1>
      <p className="text-sm text-muted-foreground">Manage your account details.</p>
      <form onSubmit={save} className="mt-6 max-w-lg space-y-4 bs-card p-6" data-testid="profile-form">
        <div><Label>Email</Label><Input value={user?.email || ""} disabled className="mt-1.5" /></div>
        <div><Label>Full name</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1.5" data-testid="profile-name" /></div>
        <div className="grid grid-cols-2 gap-3">
          <div><Label>Company</Label><Input value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} className="mt-1.5" /></div>
          <div><Label>Phone</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="mt-1.5" /></div>
        </div>
        <Button type="submit" className="rounded-full" disabled={busy} data-testid="profile-save">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Save changes</Button>
      </form>
    </div>
  );
}
